export {AuthorizationService} from './authorization';
export {AuthorizationData} from './authorization-data';



// WEBPACK FOOTER //
// ./src/app/shared/authorization/generic/index.ts